var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-modal",
    {
      attrs: { title: "提示", visible: _vm.visible },
      scopedSlots: _vm._u([
        {
          key: "footer",
          fn: function () {
            return [
              _c(
                "a-button",
                { attrs: { type: "primary" }, on: { click: _vm.handleOk } },
                [_vm._v("立即购买")]
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c("p", [
        _vm._v("您的总单量已使用完，请及时购买，以免影响系统正常使用！"),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }